import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import 'react-datepicker/dist/react-datepicker.module.css'
import { useContext, useState } from 'react';
import { ModalContent } from './shared';
// import '../../styles/ModalInfo.css'
// import '../../styles/Modal.css'
import { useMap } from 'react-leaflet';

const ModalInfo = props => {
    console.log(props)
    const map = useMap();
    const { host, hostType } = props
    const [style, setStyle] = useState('modal_info_body')

    function changeStyle(param) {
        console.log(param)
        setStyle(param)
    }

    const handleClose = () => {
        map.fire('modalclose')
    }

    return (
        host ?
            <Dialog 
                open={true}
                container={document.body}
                onClose={handleClose}
                fullScreen={window.innerWidth < 768}
                maxWidth="xl"
                fullWidth
                slotProps={{
                    
                    paper: {
                        sx: {
                            height: { xs: 'none', md: '95vh' },
                            // borderRadius: (theme) => `${theme.shape.borderRadius * 2}px`,
                            // backgroundColor: (theme) => theme.palette.background.paper,
                            // boxShadow: (theme) => theme.shadows[8],
                            // border: (theme) => `1px solid ${theme.palette.divider}`,
                        }
                    },
                    backdrop: {
                        sx: {
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        }
                    }
                }}
                scroll="paper"
            >
                <DialogTitle 
                    sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        padding: { xs: '4px 8px', md: '8px 16px'},
                        backgroundColor: 'var(--background-default)',
                        borderBottom: '1px solid var(--border-default)',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 1.5 } }}>
                        <Box 
                            sx={{ 
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: { xs: 24, md: 28 },
                                height: { xs: 24, md: 28 },
                                borderRadius: 'var(--border-radius-medium)',
                                backgroundColor: 'var(--primary-color)',
                                color: 'white',
                            }}
                        >
                            <InfoIcon sx={{ fontSize: { xs: 16, md: 18 } }} />
                        </Box>
                        <Typography 
                            variant="body1" 
                            sx={{ 
                                fontWeight: 600,
                                fontSize: { xs: '0.875rem', md: '1rem' },
                                lineHeight: 1.0,
                                color: 'var(--text-primary)',
                            }}
                        >
                            {host.name}
                        </Typography>
                    </Box>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        size="small"
                        sx={{
                            padding: { xs: '4px', md: '8px' },
                            color: 'var(--text-secondary)',
                            '&:hover': {
                                backgroundColor: 'var(--hover-bg)',
                                color: 'var(--error-color)',
                            }
                        }}
                    >
                        <CloseIcon sx={{ fontSize: { xs: 18, md: 20 } }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent  
                    
                    sx={{
                        
                        overflow: 'hidden',
                        width: '100%',
                        height: '100%',
                        padding: '0px',
                        backgroundColor: 'var(--background-paper)',
                    }}
                >
                    <ModalContent 
                        host={host} 
                        // style={changeStyle}
                        hostType={hostType}
                    />
                </DialogContent>
                <DialogActions
                    sx={{
                        display: { xs: 'none', md: ''},
                        padding: { xs: '6px 12px', md: '8px 16px' },
                        backgroundColor: 'var(--background-default)',
                        borderTop: '1px solid var(--border-default)',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Button 
                        variant="contained"
                        onClick={handleClose}
                        size="small"
                        sx={{ 
                            fontFamily: 'inherit',
                            textTransform: 'none',
                            fontSize: { xs: '0.75rem', md: '0.875rem' },
                            padding: { xs: '4px 12px', md: '6px 16px' },
                            borderRadius: (theme) => `${theme.shape.borderRadius}px`,
                        }}
                    >
                        Закрыть
                    </Button>
                </DialogActions>
            </Dialog>
            :
            null
    )
}

export default ModalInfo
